<template>
    <div>
        <div class="Opend">
            <div class="Opend_top">
                <div class="Opend_top_inset">
                    <div class="sidebar_person arrow" @click="toLogin(2)">
                        <div class="sidebar_person_icon">
                            <img v-if="isLogin" class="avatar" src="@/assets/person/avatar.png" />
                            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation"
                                class="icon-base_root-F1flk icon-base_m-F1flk" width="24" height="24" data-icon="user">
                                <path fill-rule="evenodd"
                                    d="M7.992 9.604c-1.775.013-7.18.05-7.179 3.855C.886 14.979 1.968 16 3.507 16h8.988c1.527 0 2.608-1.02 2.692-2.562.016-3.766-5.406-3.817-7.195-3.834M8.005 7.736a3.87 3.87 0 0 0 3.868-3.867A3.873 3.873 0 0 0 8.005 0a3.873 3.873 0 0 0-3.868 3.87 3.87 3.87 0 0 0 3.868 3.866"
                                    clip-rule="evenodd"></path>
                            </svg>
                        </div>
                        <div v-if="isLogin" class="sidebar_person_info">
                            <div>{{ (userInfo && userInfo.phone) ? maskNumber(userInfo.phone) : '' }}</div>
                            <div>
                                ID: {{ userInfo.id }}
                                <i class="iconfont icon-fuzhi" @click="copyText(userInfo.id)"></i>
                            </div>
                        </div>
                        <div v-else class="sidebar_person_info">
                            <div>{{ $t("login.SignIn") }}</div>
                        </div>
                    </div>
                    <div class="share_box" @click="onMenuItem('Affiliate')">
                        <div>{{ $t("person.InvitationCenter") }}</div>
                        <img src="@/assets/sidebar/invite_free.webp" />
                    </div>
                    <div v-if="device === 'mobile'" class="search_btn" @click.stop="toSearch" >
                        <div class="txt"> {{ $t("home.SearchGames") }}</div>
                        <i class="iconfont icon-sousuo"></i>
                    </div>
                    <div v-if="showThemeSkinSelect" class="theme-skin-select">
                        <span>当前皮肤</span>
                        <select v-model="themeSkin" @change="onThemeSkinChange">
                            <option v-for="item in themeSkinOptions" :key="item.value" :value="item.value">
                                {{ item.label }}
                            </option>
                        </select>
                    </div>
                    <div class="event_list gameClassify">
                        <div class="event_item W33P" :class="{ 'act': act == item.gameCategoryType || hoverAct == item.gameCategoryType }" v-for="(item, index) in gameClassify" :key="index" @click="toCasino(item)">
                            <div class="icon">
                                <img class="img" :src="item.unActivationImg" />
                                <img class="imgAct" :src="item.activationImg" />
                            </div>
                            <div class="event_name">{{ item.categoryShowName }}</div>
                        </div>
                    </div>
                    <div class="event_list">
                        <div class="event_item" :class="activeList.length >= 4 ? 'W25P' : 'W33P'" v-for="(item, index) in activeList" :key="index" @click="toItem(item)">
                            <img :src="item.homeImgUrl" alt="">
                        </div>
                    </div>
                    <!-- <div class="sidebar_line"></div> -->
                    <div class="menu-group">
                        <!-- <div class="menu-item" :class="{ 'act': pathAct == 'depositBonus' }"
                            @click="onMenuItem('depositBonus')">
                            <div class="icon">
                                <img class="img" src="@/assets/sidebar/icon_Promotion.png" />
                                <img class="imgAct" src="@/assets/sidebar/icon_PromotionAct.png" />
                            </div>
                            <div>{{ $t("person.Bonus") }}</div>
                        </div> -->
                        <div class="menu-item" :class="{ 'act': pathAct == 'Event' }" @click="onMenuItem('Event')">
                            <div class="icon">
                                <img class="img" src="@/assets/sidebar/icon_bonusAct.png" />
                                <img class="imgAct" src="@/assets/sidebar/icon_bonusAct.png" />
                            </div>
                            <div>{{ $t("person.Promotion") }}</div>
                        </div>
                        <div class="menu-item" :class="{ 'act': pathAct == 'vip' }" @click="onMenuItem('vip')">
                            <div class="icon vip">
                                <img class="img" src="@/assets/vip/vip.png" />
                                <img class="imgAct" src="@/assets/vip/vip.png" />
                            </div>
                            <div>{{ $t("person.VIPClub") }}</div>
                        </div>
                        <div class="menu-item" :class="{ 'act': pathAct == 'Affiliate' }" @click="onMenuItem('Affiliate')">
                            <div class="icon">
                                <img class="img" src="@/assets/sidebar/icon_share.png" />
                                <img class="imgAct" src="@/assets/sidebar/icon_shareAct.png" />
                            </div>
                            <div>{{ $t("tabbar.Affiliate") }}</div>
                        </div>
                        <!-- <div class="menu-item" @click="$refs.RedemptionCodePopup.open()">
                            <div class="icon icon_code" >
                                <img class="img" src="@/assets/sidebar/icon_code.png" />
                                <img class="imgAct" src="@/assets/sidebar/icon_codeAct.png" />
                            </div>
                            <div>{{ $t("RedemptionCode.RedemptionCode") }}</div>
                        </div> -->
                        <!-- <div class="menu-item" :class="{ 'act': act == 'Bonus' }" @click="onShowDownAppPopup">
                    <div class="icon">
                        <img class="img" src="@/assets/sidebar/icon_Install.png" />
                        <img class="imgAct" src="@/assets/sidebar/icon_InstallAct.png" />
                    </div>
                    <div>{{ $t("person.Install") }}</div>
                </div>
                <div class="menu-item" :class="{ 'act': act == 'Bonus' }"
                    @click="onNavTo({ url: sysConfig.telegram, type: 'href' })">
                    <div class="icon">
                        <i class="iconfont icon-kefuE"></i>
                    </div>
                    <div>{{ $t("person.LiveChat") }}</div>
                </div> -->
                    </div>
                </div>
            </div>
            <div class="Opend_bottom">
                <div class="down_box arrow" @click="onShowDownAppPopup">
                    <svg v-if="sysPlatform == 'Windows'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"
                        role="presentation" class="icon-base_root-F1flk app-banner_icon-cDjry" width="44" height="44"
                        data-icon="windows">
                        <rect width="44" height="44" fill="#00adef" rx="12"
                            style="fill:#FFD014;fill-opacity:1"></rect>
                        <path fill="#fff" fill-rule="evenodd"
                            d="M22 34c6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12 0 6.628 5.373 12 12 12m-1.56-16.75-4.68.646v3.889h4.68zm6.84-1.01-6.264.936v4.535h6.264zm-6.84 6.05h-4.68v3.886l4.68.649zm6.84 0h-6.264l.073 4.606 6.191.864z"
                            clip-rule="evenodd" style="fill:#fff;fill-opacity:1"></path>
                    </svg>
                    <svg v-if="sysPlatform == 'ios'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"
                        role="presentation" class="icon-base_root-F1flk app-banner_icon-cDjry" width="44" height="44"
                        data-icon="ios">
                        <rect width="44" height="44" fill="#0e1011" rx="12"
                            style="fill:#FFD014;fill-opacity:1"></rect>
                        <path fill="#fff"
                            d="M29.205 21.763c.024-1.853 1.043-3.606 2.66-4.576-1.02-1.422-2.728-2.324-4.506-2.378-1.895-.194-3.733 1.107-4.7 1.107-.984 0-2.471-1.088-4.073-1.056-2.087.066-4.034 1.225-5.05 3.007-2.182 3.69-.554 9.114 1.537 12.097 1.047 1.46 2.27 3.092 3.87 3.035 1.566-.064 2.15-.975 4.04-.975 1.873 0 2.422.974 4.054.938 1.68-.027 2.74-1.468 3.749-2.942a12 12 0 0 0 1.714-3.408c-1.975-.816-3.293-2.756-3.296-4.849M26.12 12.847A5.29 5.29 0 0 0 27.38 9a5.64 5.64 0 0 0-3.621 1.83 5.08 5.08 0 0 0-1.291 3.704c1.4.014 2.776-.622 3.654-1.687"
                            style="fill:#fff;fill-opacity:1"></path>
                    </svg>
                    <svg v-if="sysPlatform == 'WebAndroidGame'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"
                        role="presentation" class="icon-base_root-F1flk app-banner_icon-cDjry" width="44" height="44"
                        data-icon="android">
                        <rect width="44" height="44" fill="#34a853" rx="12"
                            style="fill:#FFD014;fill-opacity:1"></rect>
                        <path fill="#fff" fill-rule="evenodd"
                            d="m34.941 27.748.012.077c.024.186.047.372.047.566H9c.024-.194.047-.38.079-.566l.011-.077.012-.078q.08-.488.197-.953a12.6 12.6 0 0 1 1.101-2.875c.284-.534.598-1.038.952-1.526a12.7 12.7 0 0 1 2.25-2.402q.72-.591 1.51-1.077l-.007-.008q-.196-.337-.394-.67-.197-.334-.393-.67l-.23-.393q-.268-.46-.54-.917a146 146 0 0 0-.552-.938c-.039-.077-.078-.155-.102-.232-.07-.225-.07-.45-.016-.667.016-.054.032-.1.056-.155a1.211 1.211 0 0 1 1.007-.713c.078-.007.149-.007.228 0q.01.002.02.003.076.01.16.029a1.18 1.18 0 0 1 .724.542 139 139 0 0 0 .551.938l.23.392q.269.46.541.917.196.337.393.67a74 74 0 0 1 .472.81l.449-.163a13.3 13.3 0 0 1 4.17-.712h.133c1.644 0 3.21.294 4.657.836l.118.047a1 1 0 0 0 .044-.074q.02-.038.043-.073.195-.337.393-.67.199-.334.393-.67l.771-1.31.276-.47.275-.468a1.15 1.15 0 0 1 .905-.573c.078-.008.15-.008.228 0 .18.015.354.07.511.162.181.101.323.24.417.403a1 1 0 0 1 .079.147q.034.072.055.155c.063.217.055.45-.016.667a.9.9 0 0 1-.102.232l-.275.47-.276.468-.23.392q-.269.46-.54.917-.196.337-.394.67-.199.334-.393.67l-.008.013-.008.011q.861.525 1.628 1.178.354.293.685.62c.52.52.999 1.07 1.432 1.666.354.488.668 1 .952 1.526q.33.616.59 1.279c.204.511.377 1.046.51 1.596.08.318.142.636.198.953zm-6.156-2.907c.52-.34.598-1.131.165-1.759-.424-.635-1.195-.868-1.715-.527-.519.341-.597 1.132-.165 1.76.425.635 1.196.867 1.715.526m-11.784-.515c.425-.635.354-1.418-.165-1.759-.52-.34-1.29-.108-1.715.527s-.354 1.418.165 1.759c.52.34 1.282.1 1.715-.527"
                            clip-rule="evenodd" style="fill:#fff;fill-opacity:1"></path>
                    </svg>
                    <div class="down_info">
                        <div>{{ $t("footer.ApplicableTo") }} {{ sysPlatform == 'Windows' ? 'Windows' :
                            (sysPlatform == 'ios' ? 'IOS' : 'Android') }}</div>
                        <!-- <div>
                            <span>{{ $t("home.DownloadTips") }}</span>
                            <span class="money">{{ CurrencyType }}100</span>
                        </div> -->
                    </div>
                </div>
                <div class="sidebar_icons_lang">
                    <div class="sidebar_icons">
                        <img v-for="(item, index) in platforms.slice(0, 3)" :key="index" :src="item.icon"
                            @click="onNavTo({ url: item.url, type: 'href' })" />
                        <van-popover v-model="showPlatformsPopover" theme="dark" trigger="click" placement="top">
                            <div class="sidebar_icons_more_box">
                                <div class="sidebar_icons_more_header">
                                    <div>{{ $t("footer.socialMedia") }}</div>
                                    <div class="close" @click.stop="showPlatformsPopover = false">
                                        <i class="iconfont icon-s-cuowu-guanbi"></i>
                                    </div>
                                </div>
                                <div class="sidebar_icons_more_list">
                                    <div v-for="(item, index) in platforms" :key="index"
                                        @click="onNavTo({ url: item.url, type: 'href' })">
                                        <img :src="item.icon" />
                                        <div>{{ item.title }}</div>
                                    </div>
                                </div>
                            </div>
                            <template #reference>
                                <div class="sidebar_icons_more">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation"
                                        class="icon-base_root-F1flk expanded-view_moreIcon-RehQD" width="16" height="16"
                                        data-icon="more-vertical">
                                        <path fill-rule="evenodd"
                                            d="M8 11.153c.746 0 1.35.604 1.35 1.35v.006a1.35 1.35 0 1 1-2.7 0v-.006c0-.746.605-1.35 1.35-1.35M8 6.647c.746 0 1.35.604 1.35 1.35v.006a1.35 1.35 0 1 1-2.7 0v-.006c0-.746.605-1.35 1.35-1.35M8 2.141c.746 0 1.35.604 1.35 1.35v.006a1.35 1.35 0 1 1-2.7 0v-.006c0-.746.605-1.35 1.35-1.35"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                            </template>
                        </van-popover>
                    </div>
                    <div class="sidebar_lang">
                        <language :show="true" :showIcon="true">
                            <template #langType>
                                <div class="sidebar_lang_box">
                                    <div class="sidebar_lang_txt">{{ BelongNation }}</div>
                                    <svg v-if="DisabledBelongCountry !== 'disable'" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 16 16" role="presentation"
                                        class="icon-base_root-F1flk language-picker_arrowIcon-e6Mle" width="16" height="16"
                                        data-icon="arrow-bottom">
                                        <path fill-rule="evenodd"
                                            d="M2.697 5.03a.9.9 0 0 1 1.273 0L8 9.06l4.03-4.03a.9.9 0 1 1 1.273 1.273L8.637 10.97a.9.9 0 0 1-1.273 0L2.697 6.303a.9.9 0 0 1 0-1.273"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                            </template>
                        </language>
                    </div>
                </div>
                <div class="sidebar_line"></div>
                <div class="sidebar_customerService" @click="onNavTo({ url: sysConfig.telegram, type: 'href' })">
                    <div class="icon">
                        <i class="iconfont icon-kefuE"></i>
                    </div>
                    <div>{{ $t("person.LiveChat") }}</div>
                    <div>24/7</div>
                </div>
            </div>
        </div>
        <div class="PC-hide">
            <div class="Opend_top">
                <div class="Opend_inset">
                    <div class="sidebar_person" @click="toLogin(2)">
                        <div class="sidebar_person_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation"
                                class="icon-base_root-F1flk icon-base_m-F1flk" width="24" height="24" data-icon="user">
                                <path fill-rule="evenodd"
                                    d="M7.992 9.604c-1.775.013-7.18.05-7.179 3.855C.886 14.979 1.968 16 3.507 16h8.988c1.527 0 2.608-1.02 2.692-2.562.016-3.766-5.406-3.817-7.195-3.834M8.005 7.736a3.87 3.87 0 0 0 3.868-3.867A3.873 3.873 0 0 0 8.005 0a3.873 3.873 0 0 0-3.868 3.87 3.87 3.87 0 0 0 3.868 3.866"
                                    clip-rule="evenodd"></path>
                            </svg>
                        </div>
                    </div>
                    <div class="icon-item" @click="onMenuItem('Affiliate')">
                        <img src="@/assets/person/inviteSubordinates.png" />
                        <div v-if="true" class="tips">{{ $t("person.InvitationCenter") }}</div>
                    </div>
                    <div class="game_classify">
                        <div class="icon-item"
                            :class="{ 'arrow': (item.list && item.list.length), 'act': act == item.gameCategoryType || hoverAct == item.gameCategoryType }"
                            v-for="(item, index) in gameClassify" :key="index" @mouseenter="enterMenuItem(item)"
                            @mouseleave="leaveMenuItem(item)" @click.stop="toCasino(item)">
                            <img class="img" :src="item.unActivationImg" />
                            <img class="imgAct" :src="item.activationImg" />
                            <div v-if="false" class="tips">{{ item.categoryShowName }}</div>
                        </div>
                    </div>
                    <!-- <div class="icon-item" @click="onMenuItem('depositBonus')">
                        <img class="img" src="@/assets/sidebar/icon_Promotion.png" />
                        <img class="imgAct" src="@/assets/sidebar/icon_PromotionAct.png" />
                        <div v-if="true" class="tips">{{ $t("person.Bonus") }}</div>
                    </div> -->
                    <div class="icon-item" @click="onMenuItem('Event')">
                        <img class="img" src="@/assets/sidebar/icon_bonus.png" />
                        <img class="imgAct" src="@/assets/sidebar/icon_bonusAct.png" />
                        <div v-if="true" class="tips">{{ $t("person.Promotion") }}</div>
                    </div>
                    <div class="icon-item vip" @click="onMenuItem('vip')">
                        <img src="@/assets/vip/vip.png" />
                        <div v-if="true" class="tips">{{ $t("person.VIPClub") }}</div>
                    </div>
                    <div class="icon-item" @click="onMenuItem('Affiliate')">
                        <img class="img" src="@/assets/sidebar/icon_share.png" />
                        <img class="imgAct" src="@/assets/sidebar/icon_shareAct.png" />
                        <div v-if="true" class="tips">{{ $t("tabbar.Affiliate") }}</div>
                    </div>
                    <!-- <div class="icon-item icon_code" @click="$refs.RedemptionCodePopup.open()">
                        <img class="img" src="@/assets/sidebar/icon_code.png" />
                        <img class="imgAct" src="@/assets/sidebar/icon_codeAct.png" />
                        <div v-if="true" class="tips">{{ $t("RedemptionCode.RedemptionCode") }}</div>
                    </div> -->
                    <div v-if="showThemeSkinSelect" class="icon-item theme-skin-debug">
                        <select v-model="themeSkin" @change="onThemeSkinChange">
                            <option v-for="item in themeSkinOptions" :key="item.value" :value="item.value">
                                {{ item.label }}
                            </option>
                        </select>
                        <div v-if="true" class="tips">Theme</div>
                    </div>
                </div>
            </div>
            <div class="Opend_bottom">
                <div class="down_box" @click="onShowDownAppPopup">
                    <svg v-if="sysPlatform == 'Windows'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"
                        role="presentation" class="icon-base_root-F1flk app-banner_icon-cDjry" width="44" height="44"
                        data-icon="windows">
                        <rect width="44" height="44" fill="#00adef" rx="12"
                            style="fill:color(display-p3 0 .6784 .9373);fill-opacity:1"></rect>
                        <path fill="#fff" fill-rule="evenodd"
                            d="M22 34c6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12 0 6.628 5.373 12 12 12m-1.56-16.75-4.68.646v3.889h4.68zm6.84-1.01-6.264.936v4.535h6.264zm-6.84 6.05h-4.68v3.886l4.68.649zm6.84 0h-6.264l.073 4.606 6.191.864z"
                            clip-rule="evenodd" style="fill:#fff;fill-opacity:1"></path>
                    </svg>
                    <svg v-if="sysPlatform == 'ios'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"
                        role="presentation" class="icon-base_root-F1flk app-banner_icon-cDjry" width="44" height="44"
                        data-icon="ios">
                        <rect width="44" height="44" fill="#0e1011" rx="12"
                            style="fill:#0e1011;fill:color(display-p3 .0549 .0627 .0667);fill-opacity:1"></rect>
                        <path fill="#fff"
                            d="M29.205 21.763c.024-1.853 1.043-3.606 2.66-4.576-1.02-1.422-2.728-2.324-4.506-2.378-1.895-.194-3.733 1.107-4.7 1.107-.984 0-2.471-1.088-4.073-1.056-2.087.066-4.034 1.225-5.05 3.007-2.182 3.69-.554 9.114 1.537 12.097 1.047 1.46 2.27 3.092 3.87 3.035 1.566-.064 2.15-.975 4.04-.975 1.873 0 2.422.974 4.054.938 1.68-.027 2.74-1.468 3.749-2.942a12 12 0 0 0 1.714-3.408c-1.975-.816-3.293-2.756-3.296-4.849M26.12 12.847A5.29 5.29 0 0 0 27.38 9a5.64 5.64 0 0 0-3.621 1.83 5.08 5.08 0 0 0-1.291 3.704c1.4.014 2.776-.622 3.654-1.687"
                            style="fill:#fff;fill-opacity:1"></path>
                    </svg>
                    <svg v-if="sysPlatform == 'WebAndroidGame'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"
                        role="presentation" class="icon-base_root-F1flk app-banner_icon-cDjry" width="44" height="44"
                        data-icon="android">
                        <rect width="44" height="44" fill="#34a853" rx="12"
                            style="fill:#34a853;fill:color(display-p3 .2039 .6588 .3255);fill-opacity:1"></rect>
                        <path fill="#fff" fill-rule="evenodd"
                            d="m34.941 27.748.012.077c.024.186.047.372.047.566H9c.024-.194.047-.38.079-.566l.011-.077.012-.078q.08-.488.197-.953a12.6 12.6 0 0 1 1.101-2.875c.284-.534.598-1.038.952-1.526a12.7 12.7 0 0 1 2.25-2.402q.72-.591 1.51-1.077l-.007-.008q-.196-.337-.394-.67-.197-.334-.393-.67l-.23-.393q-.268-.46-.54-.917a146 146 0 0 0-.552-.938c-.039-.077-.078-.155-.102-.232-.07-.225-.07-.45-.016-.667.016-.054.032-.1.056-.155a1.211 1.211 0 0 1 1.007-.713c.078-.007.149-.007.228 0q.01.002.02.003.076.01.16.029a1.18 1.18 0 0 1 .724.542 139 139 0 0 0 .551.938l.23.392q.269.46.541.917.196.337.393.67a74 74 0 0 1 .472.81l.449-.163a13.3 13.3 0 0 1 4.17-.712h.133c1.644 0 3.21.294 4.657.836l.118.047a1 1 0 0 0 .044-.074q.02-.038.043-.073.195-.337.393-.67.199-.334.393-.67l.771-1.31.276-.47.275-.468a1.15 1.15 0 0 1 .905-.573c.078-.008.15-.008.228 0 .18.015.354.07.511.162.181.101.323.24.417.403a1 1 0 0 1 .079.147q.034.072.055.155c.063.217.055.45-.016.667a.9.9 0 0 1-.102.232l-.275.47-.276.468-.23.392q-.269.46-.54.917-.196.337-.394.67-.199.334-.393.67l-.008.013-.008.011q.861.525 1.628 1.178.354.293.685.62c.52.52.999 1.07 1.432 1.666.354.488.668 1 .952 1.526q.33.616.59 1.279c.204.511.377 1.046.51 1.596.08.318.142.636.198.953zm-6.156-2.907c.52-.34.598-1.131.165-1.759-.424-.635-1.195-.868-1.715-.527-.519.341-.597 1.132-.165 1.76.425.635 1.196.867 1.715.526m-11.784-.515c.425-.635.354-1.418-.165-1.759-.52-.34-1.29-.108-1.715.527s-.354 1.418.165 1.759c.52.34 1.282.1 1.715-.527"
                            clip-rule="evenodd" style="fill:#fff;fill-opacity:1"></path>
                    </svg>
                </div>
                <div class="sidebar_icons_lang">
                    <div class="sidebar_icons">
                        <img v-for="(item, index) in platforms.slice(0, 3)" :key="index" :src="item.icon"
                            @click="onNavTo({ url: item.url, type: 'href' })" />
                        <van-popover v-model="showPlatformsPopover" theme="dark" trigger="click" placement="right-end">
                            <div class="sidebar_icons_more_box">
                                <div class="sidebar_icons_more_header">
                                    <div>{{ $t("footer.socialMedia") }}</div>
                                    <div class="close" @click.stop="showPlatformsPopover = false">
                                        <i class="iconfont icon-s-cuowu-guanbi"></i>
                                    </div>
                                </div>
                                <div class="sidebar_icons_more_list">
                                    <div v-for="(item, index) in platforms" :key="index"
                                        @click="onNavTo({ url: item.url, type: 'href' })">
                                        <img :src="item.icon" />
                                        <div>{{ item.title }}</div>
                                    </div>
                                </div>
                            </div>
                            <template #reference>
                                <div class="sidebar_icons_more">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation"
                                        class="icon-base_root-F1flk expanded-view_moreIcon-RehQD" width="16" height="16"
                                        data-icon="more-vertical">
                                        <path fill-rule="evenodd"
                                            d="M8 11.153c.746 0 1.35.604 1.35 1.35v.006a1.35 1.35 0 1 1-2.7 0v-.006c0-.746.605-1.35 1.35-1.35M8 6.647c.746 0 1.35.604 1.35 1.35v.006a1.35 1.35 0 1 1-2.7 0v-.006c0-.746.605-1.35 1.35-1.35M8 2.141c.746 0 1.35.604 1.35 1.35v.006a1.35 1.35 0 1 1-2.7 0v-.006c0-.746.605-1.35 1.35-1.35"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                            </template>
                        </van-popover>
                    </div>
                    <div class="sidebar_lang">
                        <language :show="true" :showIcon="true">
                        </language>
                    </div>
                </div>
                <div class="sidebar_line"></div>
                <div class="sidebar_customerService" @click="onNavTo({ url: sysConfig.telegram, type: 'href' })">
                    <div class="icon">
                        <i class="iconfont icon-kefuE"></i>
                    </div>
                    <div></div>
                </div>
            </div>
        </div>
        <div v-if="PCSubMenus && PCSubMenus.list && PCSubMenus.list.length" class="sub-menus" :class="{ 'hover': isHover }"
            @mouseenter="enterMenuItem('sub')" @mouseleave="leaveMenuItem('sub')">
            <div class="sub-menus-item" :class="{ 'act': subAct == item.id }" v-for="(item, index) in PCSubMenus.list"
                :key="index" @click="toCasino(PCSubMenus, item)">
                <van-image height=".66rem" fit="contain" :src="item.iconImgUrl" />
                <!-- <span>{{ item.gamePlatformType }}</span> -->
            </div>
        </div>
        <div class="Sidebar-close-icon" @click="handleClickOutside">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation"
                class="icon-base_root-F1flk icon-base_m-F1flk" width="24" height="24" data-icon="close">
                <path fill-rule="evenodd"
                    d="M3.364 3.364a.9.9 0 0 1 1.272 0L8 6.727l3.364-3.363a.9.9 0 0 1 1.272 1.272L9.274 8l3.364 3.364a.9.9 0 1 1-1.273 1.272L8 9.274l-3.364 3.364a.9.9 0 1 1-1.272-1.273L6.727 8 3.364 4.636a.9.9 0 0 1 0-1.272"
                    clip-rule="evenodd"></path>
            </svg>
        </div>
        <pwaIosPopup ref="pwaIosPopup" :isToHome="false"></pwaIosPopup>
        <RedemptionCodePopup ref="RedemptionCodePopup"></RedemptionCodePopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getGameClassify } from '@/api/game'
import { getEventsHomeShow } from '@/api/home'
import { getCustomEventInfo } from '@/api/event'
import { Toast } from 'vant'
import handleCopy from '@/utils/copy.js'
import language from '@/components/language'
import RedemptionCodePopup from '@/components/RedemptionCodePopup'
import { getPlatform } from '@/utils'
import { domainKey, defaultThemeSkin, showThemeSkinSelect, themeSkinOptions } from '@/common/http'
import { applyThemeSkin } from '@/utils/themeSkin'
import pwaIosPopup from '@/views/downAppPWA/modules/pwaIosPopup'
let savedPwaPrompt999 = null
export default {
    name: 'Sidebar',
    components: { language, pwaIosPopup, RedemptionCodePopup },
    data() {
        return {
            sysPlatform: getPlatform(),
            domainKey,
            activeList: [],
            act: 0,
            hoverAct: 0,
            hoverActTemp: 0,
            isHover: false,
            subAct: 0,
            isShowSub: false,
            gameClassify: [],
            PCSubMenus: [],
            pathAct: '',
            platforms: [],
            showPlatformsPopover: false,
            themeSkin: window.localStorage.getItem('themeSkin') || defaultThemeSkin,
            showThemeSkinSelect,
            themeSkinOptions
        }
    },
    computed: {
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device
        }),
        mobile() {
            return this.device === 'mobile'
        },
        isLogin() {
            return !!this.$store.getters.token
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        isCollapse() {
            return !this.sidebar.opened
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        isOpened() {
            return !this.sidebar.opened
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                this.act = ''
                this.subAct = ''
                const opt = this.$route?.params
                if (opt && opt.params) {
                    const params = JSON.parse(decodeURIComponent(opt?.params))
                    this.act = params?.code
                    if (params.gameTitleId) this.subAct = params.gameTitleId
                }
                this.pathAct = this.$route.name
            },
            deep: true
        },
        sysConfig: {
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.GetPlatforms()
                }
            },
            deep: true,
            immediate: true
        },
        isOpened: {
            handler: function (newVal, oldVal) {
                if (!this.mobile && this.gameClassify.length) {
                    this.gameClassify.forEach(x => {
                        x.isShowSub = false
                    })
                }
            },
            deep: true
        }
    },
    created() {
        this.getGameClassify()
        this.getActiveInfo()
        this.act = ''
        this.subAct = ''
        const opt = this.$route?.params
        if (opt && opt.params) {
            const params = JSON.parse(decodeURIComponent(opt?.params))
            this.act = params?.code
            if (params.gameTitleId) this.subAct = params.gameTitleId
        }
        this.pathAct = this.$route.name
    },
    mounted() {
        try {
            this.$nextTick(() => {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    // 把事件存起来
                    savedPwaPrompt999 = e
                })
            })
        } catch {
            console.log('error-pwa-不支持？不显示？')
        }
    },
    methods: {
        onThemeSkinChange() {
            window.localStorage.setItem('themeSkin', this.themeSkin)
            applyThemeSkin(this.themeSkin)
            Toast('Theme switched for preview. Rebuild to make it the packaged theme.')
        },
        onClassifyTop(act) {
            const item = {
                id: act,
                gameCategoryType: act,
                categoryShowName: act,
                titleName: act
            }
            this.toCasino(item)
        },
        onMenuItem(act) {
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.pathAct = act
            this.onNavTo({ url: act, type: 'post' })
        },
        enterMenuItem(item) {
            if (item !== 'sub') {
                this.PCSubMenus = item
                this.hoverAct = item.id
                this.hoverActTemp = item.id
            } else {
                this.hoverAct = this.hoverActTemp
            }
            if (!this.mobile) this.isHover = true
        },
        leaveMenuItem(item) {
            this.hoverAct = ''
            if (!this.mobile) this.isHover = false
        },
        getGameClassify() {
            const that = this
            getGameClassify().then(res => {
                if (res?.code) return
                const D = res?.result.filter(x => x.gameTitleIPage && x.gameTitleIPage.records && x.gameTitleIPage.records.length && x.gameCategoryType !== 'None')
                const obj1 = {
                    id: 'Popular',
                    activationImg: require('@/assets/home/icon_hotAct.gif'),
                    unActivationImg: require('@/assets/home/icon_hotAct.webp'),
                    categoryShowName: this.$t('home.Popular'),
                    gameCategoryType: 'Popular',
                    favPageNum: 0,
                    favList: [],
                    RecentList: [],
                    hotPageNum: 1,
                    hotList: []
                }
                D.unshift(obj1)
                that.gameClassify = D
            })
        },
        getActiveInfo() {
            getEventsHomeShow().then((res) => {
                if (res.code) return
                const D = res.result
                this.activeList = D.eventManageList
                // if (this.activeList.length < 3) {
                //     const obj1 = {
                //         eventType: 'customerServiceTelegram',
                //         homeImgUrl: require('@/assets/sidebar/icon_telegram.gif')
                //     }
                //     this.activeList.push(obj1)
                // }
                this.$forceUpdate()
            })
        },
        onArrow(item) {
            if (this.mobile) {
                item.isShowSub = !item.isShowSub
            } else {
                this.toCasino(item)
            }
        },
        toCasino(item, citem) {
            if (this.act === item.gameCategoryType && !citem) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.act = item.gameCategoryType
            const obj = {
                iconImg: item.activationImg,
                code: item.gameCategoryType,
                title: item.categoryShowName
            }
            if (this.act === item.gameCategoryType && citem && this.subAct === citem.id) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            if (citem) {
                this.subAct = citem.id
                obj.gamePlatformType = citem.gamePlatformType
                obj.gameTitleId = citem.id
                obj.gameFactoryName = citem.gameFactoryName
            } else if (item.list && item.list.length) {
                const subItem = item.list[0]
                this.subAct = subItem.id
                obj.gamePlatformType = subItem.gamePlatformType
                obj.gameTitleId = subItem.id
                obj.gameFactoryName = subItem.gameFactoryName
            }
            const params = encodeURIComponent(JSON.stringify(obj))
            const timestamp = new Date().getTime()
            this.onNavTo({ url: 'Casino', type: 'post', params: { timestamp, params } })
        },
        toBonusRainPopup() {
            this.$store.dispatch('user/setIsShowRedPacketPopup', { show: true })
        },
        onShowDownAppPopup() {
            if (this.sysPlatform === 'WebAndroidGame') {
                this.$store.dispatch('user/setIsShowDownAppPopup', true)
            }
            if (this.sysPlatform === 'Windows') {
                if ('serviceWorker' in navigator) {
                    try {
                        savedPwaPrompt999.prompt()
                        savedPwaPrompt999.userChoice.then(choiceResult => {
                            if (choiceResult.outcome === 'accepted') {
                                // this.isShowTipsPopup = true
                                // uni.reLaunch({
                                // 	url: '/pages/index/index'
                                // })
                            } else {
                                console.log('用户拒绝安装PWA--可打印')
                            }
                        })
                    } catch (e) {
                        console.log(e, 'error-pwa-不支持？不显示？')
                        // pwaIconShow.value = false
                    }
                } else {
                    console.log('当前设备不支持')
                }
            }
            if (this.sysPlatform === 'ios') {
                this.$refs.pwaIosPopup.open()
            }
        },
        handleClickOutside() {
            this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        },
        toLogin(type) {
            if (this.isLogin) {
                this.$store.dispatch('user/setIsShowMyProfilePopup', true)
            } else {
                this.$store.dispatch('user/changeLoginType', type)
                this.$store.dispatch('user/setIsShowLoginPopup', true)
            }
        },
        GetPlatforms() {
            this.platforms = []
            const systemConfig = this.sysConfig
            const facebook = systemConfig.facebook?.trim()
            if (facebook) {
                const platform1 = {
                    id: 0,
                    icon: require('@/assets/share/icon_fackbook.png'),
                    title: 'Facebook',
                    url: facebook,
                    linkType: 'href'
                }
                this.platforms.push(platform1)
            }
            const telegram = systemConfig.telegram?.trim()
            if (telegram) {
                const platform2 = {
                    id: 1,
                    icon: require('@/assets/common/icon_service.gif'),
                    title: 'Telegram',
                    url: telegram,
                    linkType: 'href'
                }
                this.platforms.push(platform2)
            }
            const instagram = systemConfig.instagram?.trim()
            if (instagram) {
                const platform3 = {
                    id: 2,
                    icon: require('@/assets/share/icon_ins.png'),
                    title: 'Instagram',
                    url: instagram,
                    linkType: 'href'
                }
                this.platforms.push(platform3)
            }
            const youTube = systemConfig.youTube?.trim()
            if (youTube) {
                const platform4 = {
                    id: 3,
                    icon: require('@/assets/share/icon_youtube.png'),
                    title: 'Youtube',
                    url: youTube,
                    linkType: 'href'
                }
                this.platforms.push(platform4)
            }
            const whatsapp = systemConfig.whatsapp?.trim()
            if (whatsapp) {
                const platform5 = {
                    id: 4,
                    icon: require('@/assets/share/icon_whatsapp.png'),
                    title: 'Whatsapp',
                    url: whatsapp,
                    linkType: 'href'
                }
                this.platforms.push(platform5)
            }
            const twitter = systemConfig.twitter?.trim()
            if (twitter) {
                const platform6 = {
                    id: 5,
                    icon: require('@/assets/share/icon_x.png'),
                    title: 'X',
                    url: twitter,
                    linkType: 'href'
                }
                this.platforms.push(platform6)
            }
            const tiktok = systemConfig.tiktok?.trim()
            if (tiktok) {
                const platform7 = {
                    id: 6,
                    icon: require('@/assets/share/icon_tiktok.png'),
                    title: 'TikTok',
                    url: tiktok,
                    linkType: 'href'
                }
                this.platforms.push(platform7)
            }
            const telegramGroup = systemConfig.telegramGroup?.trim()
            if (telegramGroup) {
                const platform8 = {
                    id: 1,
                    icon: require('@/assets/share/icon_telegram.png'),
                    title: 'Telegram',
                    url: telegramGroup,
                    linkType: 'href'
                }
                this.platforms.push(platform8)
            }
            this.$forceUpdate()
        },
        toSearch() {
            this.$store.dispatch('user/setIsShowSearchPopup', true)
        },
        toItem(item) {
            const that = this
            // console.log(item)
            if (item.eventType === 'reliefMoney') {
                // this.$store.dispatch('user/setIsShowLossSupportPopup', { id: item.id, show: true })
                this.onNavToByIsLogin({ url: 'WeeklyRescue', params: { id: item.id }, type: 'post' })
            }
            if (item.eventType === 'signIn') {
                this.$store.dispatch('user/setIsShowCheckInPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'vipSignIn') {
                this.onNavToByIsLogin({ url: 'SignIn', params: { id: item.id }, type: 'post' })
            }
            if (item.eventType === 'luckyWheel') {
                if (this.BelongNation === 'Mexico') {
                    this.$store.dispatch('user/setIsShowTurntable2Popup', { id: item.id, show: true })
                } else {
                    this.$store.dispatch('user/setIsShowTurntablePopup', { id: item.id, show: true })
                }
            }
            if (item.eventType === 'custom') {
                getCustomEventInfo({ id: item.id }).then((res) => {
                    if (res.code) return
                    const D = res.result
                    if (D.displayMode === 'BuiltInPage') {
                        const obj = { id: D.id, eventName: D.eventName, createTime: D.createTime, eventContent: D.eventContent }
                        const params = encodeURIComponent(JSON.stringify(obj))
                        const timestamp = new Date().getTime()
                        this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
                    }
                    if (D.displayMode === 'JumpOutside') {
                        console.log(D.appSkipMode)
                        if (D.appSkipMode === 'newWindowOpen') {
                            const url = D.appHref
                            const type = 'href'
                            this.onNavTo({ url, type })
                        }
                        if (D.appSkipMode === 'nowPageOpen') {
                            // const encodedUrl = encodeURIComponent(D.appHref)
                            // const finalUrl = '/pages/webview/deposit_wv?url=' + encodedUrl
                            // this.onNavTo(finalUrl)
                        }
                        if (D.appSkipMode === 'builtInPageOpen') {
                            const url = D.appHref
                            this.onNavToByIsLogin({ url })
                        }
                    }
                })
            }
            if (item.eventType === 'redPacket') {
                // this.$store.dispatch('user/setIsShowRedPacketPopup', { id: item.id, show: true })
                if (that.homeRedPacketTypeVoList.length) {
                    this.$refs.RedPacketRain.play()
                    const showRedPacket = setTimeout(() => {
                        that.$refs.redPacket.open(that.homeRedPacketTypeVoList)
                        clearTimeout(showRedPacket)
                    }, 8800)
                }
            }
            if (item.eventType === 'extend') {
                this.onNavToByIsLogin({}).then(() => {
                    this.$store.dispatch('user/setIsShowTreasureChestPopup', { id: item.id, show: true })
                })
            }
            if (item.eventType === 'gameBetting') {
                this.$store.dispatch('user/setIsShowRebatePopup', { id: item.id, show: true })
            }
            if (item.eventType === 'rechargeRewards') {
                this.onNavTo({ url: '/Affiliate' })
            }
            if (item.eventType === 'gameBettingRewards') {
                this.onNavTo({ url: '/Affiliate' })
            }
            if (item.eventType === 'pinduoduo') {
                // this.$store.dispatch('user/setIsShowPinduoduoPopup', { id: item.id, show: true })
                this.onNavToByIsLogin({ url: 'Pinduoduo', params: { id: item.id }, type: 'post' })
            }
            if (item.eventType === 'rankingList') {
                this.$store.dispatch('user/setIsShowWinRankListPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'registerRewards') {
                if (!this.isLogin) {
                    this.$store.dispatch('user/changeLoginType', 1)
                    this.$store.dispatch('user/setIsShowLoginPopup', true)
                }
                // const obj = { type: item.eventType }
                // const params = encodeURIComponent(JSON.stringify(obj))
                // const timestamp = new Date().getTime()
                // this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
            }
            if (item.eventType === 'totalRecharge') {
                this.$store.dispatch('user/setIsShowDepositTotalPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'rechargeGift') {
                // this.$store.dispatch('user/setIsShowDepositRepeatPopup', { id: item.id, show: true })
                this.$store.dispatch('user/setIsShowDepositPopup', true)
            }
            if (item.eventType === 'usdtRechargeGift') {
                this.$store.dispatch('user/setIsShowDepositRepeatUsdtPopup', { id: item.id, show: true })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.Sidebar-close-icon {
    position: absolute;
    background: rgba(255, 255, 255, .3);
    width: .68rem;
    height: .68rem;
    top: .38rem;
    right: -.88rem;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    font-size: .34rem;
    display: none;
    cursor: pointer;

    svg {
        fill: #fff;
    }
}

.sidebar_icons_more_box {

    .sidebar_icons_more_header {
        display: flex;
        height: 1rem;
        padding-left: .24rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: .1rem;
        flex-wrap: nowrap;
        width: 4.2rem;

        &>div:first-child {
            font-size: .28rem;
            font-weight: bold;
            color: #fff;
        }

        .close {
            color: #516382;
            font-size: .36rem;
            font-weight: bold;
            height: 1rem;
            width: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
    }

    .sidebar_icons_more_list {
        padding: .2rem .28rem;
        padding-top: .06rem;

        &>div {
            display: flex;
            align-items: center;
            height: 1rem;
            color: #fff;
            font-size: .26rem;
            border-bottom: .01rem solid #555;

            &:last-child {
                border-bottom: 0;
            }

            &>img {
                height: .68rem;
                width: .68rem;
                margin-right: .2rem;
            }
        }
    }
}

.Opend {
    display: block;
    height: 100%;
    box-sizing: border-box;
    padding: 18px 10px;
    padding-right: 0;
    overflow-x: hidden;
    overflow-y: auto;
    width: 260px;
    // background: $bg-navbar-color;
    // box-shadow: 8px 0 8px #00000040;
    transition-duration: 0.3s;
    position: relative;
    z-index: 2;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
        /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
    }
}

.Opend_top {
    width: 100%;
    position: static;

    .Opend_top_inset {
        position: static;
        overflow: visible;
        padding-bottom: 0;

        &::-webkit-scrollbar {
            display: none;
            /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
        }
    }
}

.Opend_bottom {
    width: 100%;
    position: relative;
    margin-top: .12rem;
    padding-bottom: .2rem;

    &::before {
        display: none;
    }

    .down_box {
        display: flex;
        align-items: center;
        height: 46px;
        background: #554b16;
        border-radius: 12px;
        border: 1px solid #917d3d;
        text-align: left;
        padding: 0 36px 0 20px;
        margin-right: 10px;
        cursor: pointer;

        svg {
            flex: 0 0 38px;
            width: 38px;
            height: 38px;

            rect {
                width: 100%;
                height: 100%;
            }
        }

        .down_info {
            min-width: 0;
            font-size: 14px;
            color: #fff;
            flex: 1;
            margin-left: 6px;

            &>div:first-child {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            &>div:last-child {
                line-height: 18px;
                color: #b1ae9a;
            }
        }

        &.arrow {
            position: relative;

            &::after {
                content: "";
                position: absolute;
                width: 8px;
                height: 8px;
                border-radius: 1px;
                border-top: 2px solid;
                border-right: 2px solid;
                border-color: #827151;
                right: 14px;
                top: calc(50% - 5px);
                transform: rotate(45deg);
            }
        }
    }

    .sidebar_icons_lang {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: .19rem;
        margin-top: .2rem;
        padding-bottom: .3rem;

        .sidebar_icons {
            display: flex;
            align-items: center;
            gap: .02rem;

            &>img {
                width: .6rem;
                height: .6rem;
                cursor: pointer;
            }

            .sidebar_icons_more {
                width: .6rem;
                height: .6rem;
                background: $bg-btn-color;
                border: .04rem solid #DFC973;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: .2rem;
                cursor: pointer;

                svg {
                    fill: $font-color;
                }
            }
        }
    }

    .sidebar_customerService {
        display: flex;
        align-items: center;
        padding: .3rem 0;
        padding-bottom: .1rem;
        color: #fff;
        font-size: .28rem;
        position: relative;

        .icon {
            width: .78rem;
            height: .78rem;
            background: rgba(179, 182, 189, 0.12);
            border-radius: .18rem;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: .2rem;

            &>i {
                font-size: .36rem;
                color: $font-theme-color;
            }
        }

        &>div:last-child {
            position: absolute;
            background: linear-gradient(180deg, #fef3c7, #f59e0b 50%, #d97706);
            border: .04rem solid #DFC973;
            padding: .1rem .28rem;
            border-radius: .3rem;
            color: #fff;
            font-size: .26rem;
            right: .19rem;
        }
    }

    .sidebar_lang {
        background: linear-gradient(165deg, #fde68a, #fcb232 50%, #2c1800);
        background-blend-mode: overlay;
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.7), 0 1px 2px rgba(217, 119, 6, 0.2);
        border: .04rem solid #DFC973;
        border-radius: .2rem;
        padding: .01rem;

        .sidebar_lang_box {
            display: flex;
            align-items: center;
            justify-content: center;

            .sidebar_lang_txt {
                margin: 0 .08rem;
                color: #fff;
                font-size: .2rem;
            }

            svg {
                fill: #fff;
            }
        }
    }
}

.sidebar_person {
    display: flex;
    align-items: center;
    border: .02rem solid $home-activity-btn-border-color;
    background: $home-activity-btn-bg-color;
    box-shadow: inset 0 1px 0 rgba($home-white-text-color, .65), 0 .04rem .12rem rgba($font-label-color, .22);
    border-radius: .2rem;
    padding: .12rem .2rem;
    margin-bottom: .3rem;
    margin-right: .19rem;
    margin-top: .15rem;

    .sidebar_person_icon {
        background: rgba($home-white-text-color, .34);
        width: .78rem;
        height: .78rem;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            fill: $font-label-color;
        }

        .avatar{
            width: .78rem;
            height: .78rem;
            vertical-align: middle;
        }
    }

    .sidebar_person_info {
        text-align: left;
        padding-left: .2rem;
        cursor: pointer;
        font-size: .24rem;
        line-height: .33rem;
        color: rgba($font-label-color, .86);

        &>div:first-child {
            color: $font-label-color;
            font-size: .28rem;
            font-weight: 700;
        }

        .iconfont {
            color: $font-label-color;
        }
    }

    &.arrow {
        position: relative;

        &::after {
            content: "";
            position: absolute;
            width: .2rem;
            height: .2rem;
            border-radius: 1px;
            border-top: 3px solid;
            border-right: 3px solid;
            border-color: $font-label-color;
            right: .28rem;
            top: .4rem;
            transform: rotate(45deg);
        }
    }
}

.share_box {
    border-radius: .2rem;
    padding: .12rem .2rem;
    position: absolute;
    background: rgba(40, 106, 255, 0.03);
    position: relative;
    text-align: left;
    color: #fff;
    padding-right: 2.2rem;
    font-size: .26rem;
    line-height: .34rem;
    margin-top: .15rem;
    margin-bottom: .15rem;
    margin-right: .19rem;
    border: .01rem solid $border-color;
    cursor: pointer;
    & > div{
        width: 2.5rem;
    }

    &>img {
        position: absolute;
        bottom: 0;
        right: 0.08rem;
        width: 1.42rem;
        height: auto;
    }
}
.search_btn{
    // width: 100%;
    border-radius: .18rem;
    height: 0.7rem;
    color: #506180;
    font-size: .28rem;
    border: .01rem solid $border-color;
    background: rgba(40, 106, 255, 0.03);
    border-radius: .24rem;
    font-size: .28rem;
    padding: 0 .32rem;
    margin-right: .19rem;
    margin-bottom: .3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .txt {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .iconfont {
        color: #97A8C7;
        font-weight: bold;
    }
}

.event_list{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .16rem;
    margin-bottom: .2rem;

    &.gameClassify{
        .event_item{
            border: .01rem solid $border-color;
            background: rgba(40, 106, 255, 0.03);
            &:hover{
                color: #fff;
                font-weight: bold;
                background: $bg-tab-act-color;
                border: .01rem solid $font-theme-color;
                .icon{
                    & > img{
                        &.imgAct{
                            display: block;
                        }
                        &.img{
                            display: none;
                        }
                    }
                }
            }
        }
    }

    .event_item{
        // height: 1.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        // border: .01rem solid $border-color;
        background: transparent;
        border-color: transparent;
        border-radius: .15rem;
        cursor: pointer;
        color: $font-sub-color;

        &.W33P{
            width: calc(33.333333% - .18rem);
        }
        &.W25P{
            width: calc(25% - .17rem);
        }

        & > img{
            height: .88rem;
            width: .88rem;
            vertical-align: middle;
        }
        .icon{
            & > img{
                height: .68rem;
                width: .68rem;
                vertical-align: middle;

                &.imgAct{
                    display: none;
                }
            }
        }
        .event_name{
            font-size: .2rem;
        }

        &.act{
            color: #fff;
            font-weight: bold;
            background: $bg-tab-act-color;
            .icon{
                & > img{
                    &.imgAct{
                        display: block;
                    }
                    &.img{
                        display: none;
                    }
                }
            }
        }
    }
}

.sidebar_line {
    height: .01rem;
    margin: 0 auto;
    background: rgba(245, 244, 240, 0.1);
    margin-right: .19rem;
}

.PC-hide {
    box-sizing: border-box;
    width: 64px;
    height: 100%;
    // background: $bg-navbar-color;
    box-shadow: 8px 0 8px #00000040;
    display: none;
    pointer-events: none;
    transform: translateY(0);
    position: relative;
    z-index: 2;
    padding: 18px 0;
    scrollbar-width: none;
    flex-direction: column;

    &::-webkit-scrollbar {
        display: none;
        /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
    }

    .sidebar_person {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: .08rem;
        cursor: pointer;
    }

    .icon-item {
        height: 46px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 3px;
        cursor: pointer;
        position: relative;

        i.iconfont {
            font-size: .37rem;
            color: $font-sub-color;
            margin: 0 .14rem;
            display: block;

            &.icon-kefuE {
                color: $font-theme-color;
            }
        }

        .tips {
            display: none;
            position: absolute;
            right: -10px;
            height: 100%;
            transform: translateX(100%);
            border-radius: 12px;
            background: #613027;
            width: auto;
            white-space: nowrap;
            color: #fff;
            line-height: 46px;
            padding: 0 10px;

            &::before {
                border: 8px solid transparent;
                -moz-border-radius: 10px;
                border-radius: 10px;
                border-right-color: #613027;
                content: "";
                left: -14px;
                position: absolute;
                top: 15px;
                z-index: -1;
            }
        }

        &>img {
            width: 33px;
            height: 33px;
            vertical-align: middle;

            &.imgAct {
                display: none;
            }
        }

        &.vip {
            padding: 0px;

            &>img {
                width: 32px;
                height: 32px;
            }
        }

        &.icon_code{
            padding: 7px;
            padding-left: 9px;

            &>img {
                width: 20px;
                height: 20px;
            }
        }

        &.act,
        &:hover {
            &>.tips {
                display: block !important;
            }

            &>img {
                &.imgAct {
                    display: block;
                }

                &.img {
                    display: none;
                }
            }

            &.arrow {
                &::after {
                    border-color: #827751;
                }
            }
        }

        &.arrow {
            position: relative;

            &::after {
                content: "";
                position: absolute;
                width: 6px;
                height: 6px;
                border-radius: 1px;
                border-top: 2px solid;
                border-right: 2px solid;
                border-color: #827751;
                right: 10px;
                top: 6px;
            }
        }
    }

    .Opend_bottom {
        display: flex;
        flex-direction: column;
        align-items: center;

        .down_box {
            background: transparent;
            padding: 0;
            margin: 0 auto;
        }
    }

    .sidebar_icons_lang {
        flex-direction: column;
        padding-right: 0;

        .sidebar_icons {
            flex-wrap: wrap;
            justify-content: center;
            gap: .02rem;
            width: .88rem;
            height: .88rem;
            border-radius: .12rem;
            background: rgba(189, 185, 179, 0.12);

            &>img {
                width: .4rem;
                height: .4rem;
                vertical-align: middle;
            }

            .sidebar_icons_more {
                width: .4rem;
                height: .4rem;
            }
        }

        .sidebar_lang {
            width: .88rem;
            margin-top: .2rem;
        }
    }

    .sidebar_customerService {
        border-top: .01rem solid rgba(245, 243, 240, 0.1);

        .icon {
            margin-right: 0;
            cursor: pointer;
        }

        &>div {
            display: none;
        }
    }
}

.menus-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    margin-right: 10px;

    &>.menu-item {
        padding: 0;
        padding-left: 7px;
        border: .01rem solid $border-color;
        background: rgba(40, 106, 255, 0.03);

        &:first-child {
            background: linear-gradient(0deg, #3e2020 13.78%, #1d2027 113.26%);
        }

        &:last-child {
            background: linear-gradient(0deg, #3d2857 12.58%, #1d2027 95.76%);
        }

        .text {
            color: #fff;
            font-size: 12px;
            line-height: 12px;
            width: calc(100% - 34px);
            text-align: left;
            font-weight: bold;
        }
    }
}

.menu-item-wrap {
    padding-right: 10px;
}

.mobile-sub-menus {
    background: #161208;
    border-radius: 0 0 12px 12px;
    padding: 4px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;

    &>.sub-menus-item {
        background: #433c23;
        border-radius: 12px;
        width: calc(50% - 2px);
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $font-sub-color;
        cursor: pointer;

        &>span {
            margin-left: .16rem;
        }

        &.act,
        &:hover {
            color: #fff;
            font-weight: bold;
            background: $font-theme-color;
        }
    }
}

.menu-item {
    width: 100%;
    // background: #1d2027;
    color: #f2f559;
    height: 46px;
    font-size: 14px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    padding: 0 13px 0 20px;
    margin-top: 4px;
    cursor: pointer;
    position: relative;

    .icon {
        margin-right: 6px;

        i.iconfont {
            font-size: .36rem;
            color: $font-sub-color;
            margin: 0 .1rem;
            display: block;

            &.icon-kefuE {
                color: $font-theme-color;
            }
        }

        &>img {
            width: 38px;
            height: 33px;
            vertical-align: middle;
            object-fit: contain;

            &.imgAct {
                display: none;
            }
        }

        &.vip {
            padding: 2px;

            &>img {
                width: 34px;
                height: 34px;
            }
        }
        &.icon_code{
            padding: 7px;
            padding-left: 9px;

            &>img {
                width: 20px;
                height: 20px;
            }
        }
    }

    &.act,
    &:hover {
        color: #fff;
        font-weight: bold;
        background: $font-theme-color;

        .icon {
            &>img {
                &.imgAct {
                    display: block;
                }

                &.img {
                    display: none;
                }
            }
        }

        &.arrow {
            &::after {
                border-color: #fff;
            }
        }
    }

    .arrow {
        position: absolute;
        color: #827751;
        width: .8rem;
        height: .8rem;
        top: calc(50% - .4rem);
        right: 0;
        font-size: .26rem;
        transform: rotate(-90deg);
        display: flex;
        align-items: center;
        justify-content: center;

        // &::after {
        //     content: "";
        //     position: absolute;
        //     width: 10px;
        //     height: 10px;
        //     border-radius: 1px;
        //     border-top: 2px solid;
        //     border-right: 2px solid;
        //     border-color: #516382;
        //     right: 16px;
        //     top: 18px;
        //     transform: rotate(45deg);
        //     transition-duration: 0.3s;
        // }

        &.botArrow {
            transform: rotate(-180deg);
        }

        &.topArrow {
            border-radius: 12px 12px 0 0;
            transform: rotate(0deg);
            margin-top: .03rem;
        }
    }
}

.game_classify {
    margin: .3rem 0;
    width: 100%;

    .game_classify_top {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        padding-right: 10px;

        &>div {
            width: 33.3333333%;
            height: 46px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(180deg, #fef3c7, #f5ab0b, #492801);
            border: .04rem solid #fadf72;
            box-shadow: inset 0 1px 2px rgba(255,255,255,0.6), 0 2px 4px rgba(217, 119, 6, 0.3);
            background-blend-mode: overlay;
            color: rgba(255, 255, 255, .6);
            cursor: pointer;

            &>i {
                font-size: 20px;
            }

            &.act,
            &:hover:not(.disabled) {
                color: #fff;
                background: $font-theme-color;
            }

            &.disabled {
                opacity: .6;
                cursor: not-allowed;
            }
        }
    }
}

.menu-group {
    // background: #1d2027;
    // background: #432B23;
    border-radius: 12px;
    margin-top: 4px;
    overflow: hidden;
    margin-right: 10px;
    margin-top: .3rem;

    .menu-item {
        margin-top: 0;
        // border-radius: 0;
    }
}

.sub-menus {
    height: 100%;
    position: absolute;
    width: 200px;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: $bg-popup-color;
    top: 0;
    right: -200px;
    box-shadow: 5px 0 5px #00000030;
    display: none;

    &.hover {
        display: block;
    }

    .sub-menus-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.8rem;
        padding: 0 18px;
        color: $font-sub-color;
        cursor: pointer;

        ::v-deep .van-image {
            .van-image__img {
                filter: grayscale(100%);

                &:hover {
                    filter: grayscale(0%);
                }
            }
        }

        &>span {
            margin-left: .16rem;
        }

        &.act {
            background: $font-theme-color;

            ::v-deep .van-image {
                .van-image__img {
                    filter: grayscale(0%);
                }
            }
        }

        &:hover {
            color: #fff;
            font-weight: bold;
            background: $font-theme-color;
        }
    }
}

.theme-skin-select {
    margin: .2rem .1rem 0 0;
    padding: .14rem .16rem;
    border: 1px solid $border-active-color;
    border-radius: .18rem;
    background: $theme-card-color;
    color: $font-title-color;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .16rem;
    font-size: .22rem;

    select {
        max-width: 2.4rem;
        height: .48rem;
        border: 1px solid $border-input-color;
        border-radius: .12rem;
        background: $bg-input-color;
        color: $font-title-color;
        outline: none;
        padding: 0 .12rem;
        font-size: .22rem;
    }
}

.theme-skin-debug {
    select {
        width: .72rem;
        height: .48rem;
        border: 1px solid $border-active-color;
        border-radius: .1rem;
        background: $bg-input-color;
        color: $font-title-color;
        font-size: .18rem;
        outline: none;
    }
}

html[data-device-nodesktop="1"] {
    .PC-hide {
        display: flex;
    }
}

html[data-device-nodesktop="0"] {
    .PC-hide {
        display: none;
    }
}</style>
